
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#41807a","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1760.508a9.111 9.111 0 003.672-.747 9.726 9.726 0 005.078-5.075 9.43 9.43 0 000-7.334 9.731 9.731 0 00-5.093-5.086 9.406 9.406 0 00-7.324 0 9.731 9.731 0 00-5.083 5.083 9.4 9.4 0 00.007 7.337 9.758 9.758 0 005.08 5.075 9.087 9.087 0 003.663.747zm-1.035-4.951a.968.968 0 01-.464-.112 1.249 1.249 0 01-.4-.356l-2.281-2.794a.983.983 0 01-.186-.308.951.951 0 01-.059-.327.788.788 0 01.234-.571.764.764 0 01.566-.239.881.881 0 01.381.083.951.951 0 01.342.308l1.826 2.334 3.877-6.211a.829.829 0 01.713-.449.912.912 0 01.581.205.662.662 0 01.259.547.784.784 0 01-.073.327 2.179 2.179 0 01-.171.308l-4.325 6.784a1.089 1.089 0 01-.361.352.909.909 0 01-.46.119z"}})])])
          )
        }
      }
    